import baseAxios from 'redaxios'

interface HeadersObject extends Record<string, string> {
  'Content-Type': string
  'pragma': string
  'cache-control': string
  'Accept-Language': string
}

function getHeaders(): HeadersObject {
  const headers: HeadersObject = {
    'Content-Type': 'application/json',
    'pragma': 'no-cache',
    'cache-control': 'no-cache',
    'Accept-Language': window ? window.navigator.language : 'en',
  }

  const csrfToken = document.querySelector<HTMLInputElement>('#csrf > input')

  if (csrfToken !== null)
    headers['X-RequestVerificationToken'] = csrfToken.value

  return headers
}

export const axios = baseAxios.create({
  headers: getHeaders(),
  withCredentials: true,
})

export function sanitizeObject<T extends Record<string, any>>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== ''),
  ) as Partial<T>
}
